export default __webpack_public_path__ + "static/media/typeTruck.5b0b51e9.svg";